import { LabelLayers, ScadaLabel } from 'components/dashboard/scada/scadaTypes';
import { create } from 'zustand'

type Scada = {
	scadaId: string;
	labels: ScadaLabel[];
	labelLayers: LabelLayers[];
}

type ScadaLabelsState = {
	scadaMap: Map<string, Scada>;
  addScada: (scada: Scada) => void;
	updateScadaLabelLayers: (id: string, layers: LabelLayers[]) => void;
	updateScadaLabels: (id: string, labels: ScadaLabel[]) => void;
  updateScadaLabelXY: (id: string, identifier: string, x: number, y: number) => void;
};

export const useScadaStore = create<ScadaLabelsState>()(
			set => ({
				scadaMap: new Map<string, Scada>(),
				updateScadaLabelLayers: (id, layers) =>
					set(state => {
						const scada = state.scadaMap.get(id)
						if (!scada) return state;
						state.scadaMap.set(id, { ...scada, labelLayers: layers });
						return state;
					}),
				addScada: newScada =>
					set(state => { 
						state.scadaMap.set(newScada.scadaId, newScada);
						return state
					}),
				updateScadaLabels: (id, labels) => 
					set(state => {
						const scada = state.scadaMap.get(id)
						if (!scada) return state;
						state.scadaMap.set(id, {...scada, labels});
						return state;
					}),
				updateScadaLabelXY: (id, identifier, x, y) =>
					set(state => {
						const scada = state.scadaMap.get(id)
						if (!scada) return state;
						const labels = scada.labels.map(l =>
							l.identifier === identifier ? { ...l, xCoord: x, yCoord: y } : l,
						);
						state.scadaMap.set(id, { ...scada, labels });
						return state;
				}),
			}),

);